<!-- WEB -->
<div id="{{'container-' + productCard.detailProduct.itemCode | lowercase }}" class="card-content-product"
  *ngIf="!isMobile" [ngClass]="productCard.detailProduct.itemCodeHasMissing ? 'disabled-product-not-available':''">
  <div class="row no-margin no-padding">
    <div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 pl-0 product-image" *ngIf="!isNotOrderSap">
      <app-product-image [product]="productCard.detailProduct" [imgUrl]="imgUrl" [circle]="false" [radius]="true"
        [imageOpacity]="productCard.detailProduct.itemCodeHasMissing">
      </app-product-image>
    </div>
    <div class="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 no-margin no-padding text-size-2">
      <div class="row width-100 no-margin no-padding justify-content-between">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex space-gap pl-0 mb-2"
          *ngIf="isNotOrderSap || isNotStatusSap">
          <div class="product-info mr-3" *ngIf="isNotOrderSap">
            <p class="font-omicron-bold color-black mb-1 title-product">Pedido SAP</p>
            <p class="font-omicron-medium color-gray-omicron mb-0 info">
              {{ productCard.detailProduct.pedidoId }}
            </p>
          </div>

          <div class="product-info" *ngIf="isNotStatusSap">
            <p class="font-omicron-bold color-black mb-1 title-product">Estatus pedido</p>
            <p class="font-omicron-mediumcolor-gray-omicron mb-0 info">
              <span
                *ngIf="productCard.detailProduct.typeStatus !== '' && productCard.detailProduct.typeStatus !== null">
                {{ productCard.detailProduct.typeStatus }}
              </span>
              <span
                *ngIf="productCard.detailProduct.typeStatus !== '' && productCard.detailProduct.typeStatus !== null && productCard.detailProduct.status !== '' && productCard.detailProduct.status !== null">
                :
              </span>
              <span *ngIf="productCard.detailProduct.status !== '' && productCard.detailProduct.status !== null">
                {{ productCard.detailProduct.status }}
              </span>
              <span *ngIf="(productCard.detailProduct.typeStatus === '' || productCard.detailProduct.typeStatus === null ) 
              && (productCard.detailProduct.status === '' || productCard.detailProduct.status === null)">
                --
              </span>
            </p>
          </div>
        </div>
        <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 pl-0 pr-0 product-info" [ngClass]="
            productCard.detailProduct.isPackage
              ? 'd-flex align-items-center'
              : ''
          ">
          <p class="font-omicron-bold color-black mb-1 title-product" *ngIf="!productCard.detailProduct.isPackage">
            Producto
          </p>
          <p class="color-black color-gray-omicron info" [ngClass]="
              productCard.detailProduct.isPackage
                ? 'font-omicron-bold'
                : 'font-omicron-medium'
            ">
            {{ productCard.detailProduct.itemCode }}
            <span *ngIf="
                showAsteriskPackages && productCard.detailProduct.isPackage
              " class="font-omicron-bold packages-not-included-color">*</span>
          </p>
        </div>

        <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 pr-0 product-info">
          <ng-container [ngTemplateOutlet]="costPerPiece"></ng-container>
        </div>
        <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center product-info">
          <p class="font-omicron-bold color-black mb-1 title-product">Costo total</p>
          <p id="{{ 'price-' + productCard.detailProduct.itemCode | lowercase }}"
            class="font-omicron-medium color-black color-gray-omicron info">
            <ng-container *ngIf="productCard.detailProduct.displayPrices as prices; else totalDashWeb">${{
              prices.total | numberNotRound }}</ng-container>
            <ng-template #totalDashWeb>—</ng-template>
          </p>
        </div>
        <div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1" *ngIf="
            showFavoriteButton &&
            !productCard.detailProduct.isPackage &&
            !isShowSelects
          ">
          <div class="icon-size">
            <app-favorite [whoRequest]="productCard.callPlace" [index]="productCard.index" [container]="
                productCard.detailProduct.productAttributes[0].container
              " [label]="productCard.detailProduct.productAttributes[0].label"
              [description]="productCard.detailProduct.description" [isLine]="productCard.detailProduct.isLine"
              [itemCode]="productCard.detailProduct.itemCode" [isFavorite]="
                productCard.detailProduct.productAttributes[0].isFavorite
              " [configFavorite]="configFavorite" [attributeIndex]="0" [emitChangeFavorite]="true"
              (favoriteChangeEmitter)="favoriteChange($event)">
            </app-favorite>
          </div>
        </div>
        <div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1"
          *ngIf="showAddtoCarButton && !isShowSelects && !isAdvisorRoles">
          <div class="icon-size">
            <app-shopping-cart-button [request]="productCard.callPlace" [container]="
                productCard.detailProduct.productAttributes[0].container
              " [label]="productCard.detailProduct.productAttributes[0].label" [quantity]="
                productCard.detailProduct.productAttributes[0].quantity
              " [isLine]="productCard.detailProduct.isLine" [itemCode]="productCard.detailProduct.itemCode"
              [configCartButton]="configCardButton" [disable]="isCardDisabled"
              [isPackage]="productCard.detailProduct.isPackage">
            </app-shopping-cart-button>
          </div>
        </div>

        <div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1" *ngIf="isShoppingCard && isContainerAndLabelEditable">
          <div class="icon-size">
            <app-delete-product id="{{'btn-' + productCard.detailProduct.itemCode + '-delete' | lowercase }}"
              [typeDelete]="typeDeleteOptions.deleteProductFromListShoppingCar" [product]="productCard.detailProduct"
              [message]="
                productCard.detailProduct.isPackage
                ? messages.deletePackageCard
                : typeCart === typeCartStatus.savedCart
                ? messages.deleteProductCardSaved 
                : messages.deleteProductCard
              " [completeDeleteShoppingCart]="true" (wasDeleted)="deleteProductListShoppingCart($event)"
              [callPlace]="callPlace" [typeCart]="typeCart"></app-delete-product>
          </div>
        </div>
        <div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1" *ngIf="isdetailOrderEdit">
          <div class="icon-size">
            <app-delete-product [typeDelete]="
                typeDeleteOptions.deleteProductFromDetailOrderListEdit
              " [product]="productCard.detailProduct" [message]="
                productCard.detailProduct.isPackage
                  ? messages.deletePackageCard
                  : messages.deleteProductListOrder
              " (wasDeleted)="deleteProductToRepurchase()" [callPlace]="callPlaceEditOrder" [typeCart]="typeCart">
            </app-delete-product>
          </div>
        </div>

        <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 pl-0 mb-2 product-info" *ngIf="!isShowSelects">
          <p class="font-omicron-bold color-black mb-1 title-product no-wrap-text">
            {{
            productCard.detailProduct.isPackage
            ? "Cantidad de paquetes"
            : "Cantidad de piezas"
            }}
          </p>
          <div class="width-100 subtitle-product"
            *ngIf="isdetailOrderEdit || (isShoppingCard && isContainerAndLabelEditable)">
            <app-counter-pieces id="{{'pieces-' + productCard.detailProduct.itemCode | lowercase }}" [matStyle]="true"
              [pieceInit]="
                productCard.detailProduct.productAttributes[0].quantity
              " [isPackage]="productCard.detailProduct.isPackage" (newpieceEmitter)="newPieces($event, 0)"
              (lockItems)="newPieces($event, 0)">
            </app-counter-pieces>
          </div>
          <div *ngIf="!isdetailOrderEdit && !isShoppingCard || (isShoppingCard && !isContainerAndLabelEditable)">
            <p id="{{ 'produt-pieces-' + productCard.detailProduct.itemCode | lowercase }}"
              class="font-omicron-medium color-black color-gray-omicron subtitle-product info">
              {{ productCard.detailProduct.quantity }}
            </p>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-0 mb-2 product-info">
          <p class="font-omicron-bold color-black mb-1 title-product">Descripción</p>
          <p class="mb-0 font-omicron-medium color-black color-gray-omicron info">
            {{ productCard.detailProduct.description }}
          </p>
          <app-no-available-item-message [product]="productCard.detailProduct" [isProductMessage]="true"
            [isInvalidFromProduct]="productCard.detailProduct.isInvalidFromProduct">
          </app-no-available-item-message>
        </div>
        <app-hoffman-message [hoffmanTextFlag]="hoffmanTextFlag"></app-hoffman-message>
      </div>
    </div>
  </div>

  <div *ngFor="
      let productAttribute of productCard.detailProduct.productAttributes;
      let index = index
    ">
    <div class="row width-100 no-margin no-padding product-card-attributes justify-content-between mb-2" *ngIf="isShowSelects">
      <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 pl-0 pr-0 ">
        <ng-container *ngTemplateOutlet="
            isContainerAndLabelEditable ? containerSelector : containerInfo;
            context: { index: index }
          ">
        </ng-container>
      </div>
      <div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 pl-0 pr-0">
        <ng-container *ngTemplateOutlet="
            isContainerAndLabelEditable ? labelSelector : labelInfo;
            context: { index: index }
          ">
        </ng-container>
      </div>
      <div class="product-info" [ngClass]="
          (isShoppingCard && isContainerAndLabelEditable) || isdetailOrderEdit
            ? 'col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 pl-0 pr-0'
            : 'col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 pl-0 pr-0'
        ">
        <p class="font-omicron-bold color-black mb-1 text-center title-product no-wrap-text" *ngIf="index === 0">
          {{
          productCard.detailProduct.isPackage
          ? "Cantidad de paquetes"
          : "Cantidad de piezas"
          }}
        </p>
        <div class="width-100 info" *ngIf="isdetailOrderEdit || (isShoppingCard && isContainerAndLabelEditable)">
          <app-counter-pieces id="{{'pieces-' + productCard.detailProduct.itemCode | lowercase }}" [matStyle]="true"
            [pieceInit]="
              productCard.detailProduct.productAttributes[index].quantity
            " [isPackage]="productCard.detailProduct.isPackage" (newpieceEmitter)="newPieces($event, index)"
            (lockItems)="newPieces($event, index)">
          </app-counter-pieces>
        </div>
        <div *ngIf="!isdetailOrderEdit && !isShoppingCard || (isShoppingCard && !isContainerAndLabelEditable)"
          class="text-center info">
          <p class="font-omicron-medium color-gray-omicron mb-0 text-center info">
            {{
            productCard.detailProduct.productAttributes[index].quantity
            | displayDefaultZero
            }}
          </p>
        </div>
      </div>
      <div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 text-center pl-0 pr-0 product-info">
        <p class="font-omicron-bold color-black mb-1 title-product" *ngIf="index === 0">
          Costo
        </p>
        <p *ngIf="productCard.detailProduct.productAttributes[index].costPerPiece ===
          productCard.detailProduct.productAttributes[index].costPerPieceDiscount"
          class="font-omicron-medium color-gray-omicron info mb-0">
          ${{
          productCard.detailProduct.productAttributes[index].displayProductPrices.total | numberNotRound
          }}
        </p>
        <ng-container *ngIf="productCard.detailProduct.productAttributes[index].costPerPiece !==
          productCard.detailProduct.productAttributes[index].costPerPieceDiscount">
          <p class="font-omicron-medium color-gray-omicron info mb-0 discount">
            ${{
            productCard.detailProduct.productAttributes[index].displayProductPrices.totalWithoutDiscount |
            numberNotRound
            }}
          </p>
          <p class="discount-code font-omicron-medium info mb-0">
            ${{
            productCard.detailProduct.productAttributes[index].displayProductPrices.total | numberNotRound
            }}
          </p>
        </ng-container>
      </div>
      <div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 pl-0 pr-0" *ngIf="
          showFavoriteButton &&
          !productCard.detailProduct.isPackage &&
          isShowSelects
        ">
        <div class="icon-size">
          <app-favorite [whoRequest]="productCard.callPlace" [index]="productCard.index" [container]="
              productCard.detailProduct.productAttributes[index].container
            " [label]="productCard.detailProduct.productAttributes[index].label" [isFavorite]="
              productCard.detailProduct.productAttributes[index].isFavorite
            " [isLine]="productCard.detailProduct.isLine" [itemCode]="productCard.detailProduct.itemCode"
            [description]="productCard.detailProduct.description" [configFavorite]="configFavorite"
            [attributeIndex]="index" [emitChangeFavorite]="true" (favoriteChangeEmitter)="favoriteChange($event)">
          </app-favorite>
        </div>
      </div>
      <div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 pl-0 pr-0"
        *ngIf="showAddtoCarButton && isShowSelects && !isAdvisorRoles">
        <div class="icon-size">
          <app-shopping-cart-button [request]="productCard.callPlace" [container]="
              productCard.detailProduct.productAttributes[index].container
            " [label]="productCard.detailProduct.productAttributes[index].label" [quantity]="
              productCard.detailProduct.productAttributes[index].quantity
            " [isLine]="productCard.detailProduct.isLine" [itemCode]="productCard.detailProduct.itemCode"
            [configCartButton]="configCardButton" [disable]="isCardDisabled"
            [isPackage]="productCard.detailProduct.isPackage">
          </app-shopping-cart-button>
        </div>
      </div>
      <div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 pl-0 pr-0" *ngIf="
          isShoppingCard && isContainerAndLabelEditable &&
          isShowSelects &&
          productCard.detailProduct.productAttributes.length > 1
        ">
        <div class="icon-size">
          <app-delete-product [product]="productCard.detailProduct" [message]="
              getDeleteMessage(
                productCard.detailProduct.productAttributes[index].container
              )
            " [typeDelete]="typeDeleteOptions.deleteProductFromListShoppingCar" [attributeIndex]="index"
            (wasDeleted)="deleteProductListShoppingCart($event)" [callPlace]="callPlace" [typeCart]="typeCart">
          </app-delete-product>
        </div>
      </div>
      <div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 pl-0 pr-0" *ngIf="
          isdetailOrderEdit &&
          isShowSelects &&
          productCard.detailProduct.productAttributes.length > 1
        ">
        <div class="icon-size">
          <app-delete-product [product]="productCard.detailProduct" [message]="
              getDeleteMessage(
                productCard.detailProduct.productAttributes[index].container
              )
            " [typeDelete]="
              typeDeleteOptions.deleteProductFromDetailOrderListEdit
            " (wasDeleted)="deleteProductAttributeToRepurchase(index)" [callPlace]="callPlaceEditOrder"
            [typeCart]="typeCart">
          </app-delete-product>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-0 mt-2 d-flex justify-content-start product-info"
    *ngIf="isShowSelects && isContainerAndLabelEditable">
    <p class="color-omicron font-omicron-medium text-underline cursor-pointer info" (click)="addContainer()">
      Agregar otro envase
    </p>
  </div>
  <div class="row mt-3 text-size-2" *ngIf="isUtility ">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex wrap align-items-center text-center">
      <div class="d-flex justify-content-around border-top r-gap sepation-gap wrap"
        [ngClass]="isdetailOrderEdit ? 'width-100':''">
        <ng-container *ngTemplateOutlet="utilityContent"></ng-container>
      </div>
      <div class="ml-auto">
        <ng-container *ngTemplateOutlet="moveShoppingCar context: { itemCode: productCard.detailProduct.itemCode }">
        </ng-container>
      </div>
    </div>
  </div>
  <div class="row mt-3 text-size-2 d-flex justify-content-end text-center pr-3" *ngIf="(productCard.detailProduct.isPackage && showAddToSaveListShoppingCar && !isAdvisorRoles )
  || (productCard.detailProduct.isPackage &&  showAddToListShoppingCar && !isAdvisorRoles)">
    <ng-container *ngTemplateOutlet="moveShoppingCar context: { itemCode: productCard.detailProduct.itemCode }">
    </ng-container>
  </div>
</div>

<!-- MOBILE -->
<div class="card-content-product text-size-low " *ngIf="isMobile"
  [ngClass]="productCard.detailProduct.itemCodeHasMissing ? 'disabled-product-not-available':''">
  <div class="row no-margin no-padding">
    <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 pl-0 product-image" *ngIf="!isNotOrderSap">
      <app-product-image [product]="productCard.detailProduct" [imgUrl]="imgUrl" [circle]="false" [radius]="true"
        [imageOpacity]="productCard.detailProduct.itemCodeHasMissing">
      </app-product-image>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex space-gap pl-0 mb-2"
      *ngIf="isNotOrderSap || isNotStatusSap">
      <div class="product-info mr-3" *ngIf="isNotOrderSap">
        <p class="font-omicron-bold color-black mb-1 title-product">Pedido SAP</p>
        <p class="font-omicron-medium color-gray-omicron mb-0 info">
          {{ productCard.detailProduct.pedidoId }}
        </p>
      </div>

      <div class="product-info" *ngIf="isNotStatusSap">
        <p class="font-omicron-bold color-black mb-1 title-product">Estatus pedido</p>
        <p class="font-omicron-mediumcolor-gray-omicron mb-0 info">
          <span *ngIf="productCard.detailProduct.typeStatus !== '' && productCard.detailProduct.typeStatus !== null">
            {{ productCard.detailProduct.typeStatus }}
          </span>
          <span
            *ngIf="productCard.detailProduct.typeStatus !== '' && productCard.detailProduct.typeStatus !== null && productCard.detailProduct.status !== '' && productCard.detailProduct.status !== null">
            :
          </span>
          <span *ngIf="productCard.detailProduct.status !== '' && productCard.detailProduct.status !== null">
            {{ productCard.detailProduct.status }}
          </span>
          <span *ngIf="(productCard.detailProduct.typeStatus === '' || productCard.detailProduct.typeStatus === null ) 
          && (productCard.detailProduct.status === '' || productCard.detailProduct.status === null)">
            --
          </span>
        </p>
      </div>
    </div>
    <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 pl-0 pr-0 product-info" [ngClass]="
        productCard.detailProduct.isPackage && !productCard.detailProduct.itemCodeHasMissing  ? 'd-flex align-items-center' : ''
      ">
      <p class="font-omicron-bold color-black mb-1 title-product" *ngIf="!productCard.detailProduct.isPackage">
        Producto
      </p>
      <p class="font-omicron-medium color-black color-gray-omicron info">
        {{ productCard.detailProduct.itemCode }}
        <span *ngIf="showAsteriskPackages && productCard.detailProduct.isPackage"
          class="font-omicron-bold packages-not-included-color">*</span>
      </p>
      <app-no-available-item-message [product]="productCard.detailProduct" [isProductMessage]="true"
        [isInvalidFromProduct]="productCard.detailProduct.isInvalidFromProduct">
      </app-no-available-item-message>
    </div>
    <div
      class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 pl-0 pr-0 d-flex flex-column align-items-end justify-content-top space-gap mb-2">
      <div class="icon-size" *ngIf="
          showFavoriteButton &&
          !productCard.detailProduct.isPackage &&
          !isShowSelects
        ">
        <app-favorite [whoRequest]="productCard.callPlace" [index]="productCard.index"
          [container]="productCard.detailProduct.productAttributes[0].container"
          [label]="productCard.detailProduct.productAttributes[0].label"
          [description]="productCard.detailProduct.description" [isLine]="productCard.detailProduct.isLine"
          [itemCode]="productCard.detailProduct.itemCode" [isFavorite]="
            productCard.detailProduct.productAttributes[0].isFavorite
          " [configFavorite]="configFavorite" [attributeIndex]="0" [emitChangeFavorite]="true"
          (favoriteChangeEmitter)="favoriteChange($event)">
        </app-favorite>
      </div>
      <div class="icon-size" *ngIf="showAddtoCarButton && !isShowSelects && !isAdvisorRoles">
        <app-shopping-cart-button [request]="productCard.callPlace"
          [container]="productCard.detailProduct.productAttributes[0].container"
          [label]="productCard.detailProduct.productAttributes[0].label"
          [quantity]="productCard.detailProduct.productAttributes[0].quantity"
          [isLine]="productCard.detailProduct.isLine" [itemCode]="productCard.detailProduct.itemCode"
          [configCartButton]="configCardButton" [disable]="isCardDisabled"
          [isPackage]="productCard.detailProduct.isPackage">
        </app-shopping-cart-button>
      </div>
      <div class="icon-size" *ngIf="isShoppingCard && isContainerAndLabelEditable">
        <app-delete-product [product]="productCard.detailProduct" [message]="
          productCard.detailProduct.isPackage
          ? messages.deletePackageCard
          : typeCart === typeCartStatus.savedCart
          ? messages.deleteProductCardSaved 
          : messages.deleteProductCard
          " [completeDeleteShoppingCart]="true" (wasDeleted)="deleteProductListShoppingCart($event)"
          [typeDelete]="typeDeleteOptions.deleteProductFromListShoppingCar" [callPlace]="callPlace"
          [typeCart]="typeCart">
        </app-delete-product>
      </div>
      <div class="icon-size" *ngIf="isdetailOrderEdit">
        <app-delete-product [product]="productCard.detailProduct" [message]="
            productCard.detailProduct.isPackage
              ? messages.deletePackageCard
              : messages.deleteProductListOrder
          " [typeDelete]="typeDeleteOptions.deleteProductFromDetailOrderListEdit"
          (wasDeleted)="deleteProductToRepurchase()" [callPlace]="callPlaceEditOrder" [typeCart]="typeCart">
        </app-delete-product>
      </div>
    </div>
    <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 pl-0 product-info">
      <ng-container [ngTemplateOutlet]="costPerPiece"></ng-container>
    </div>
    <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 pr-0 text-center product-info">
      <p class="font-omicron-bold color-black mb-1 title-product">Costo total</p>
      <p class="font-omicron-medium color-gray-omicron info">
        <ng-container *ngIf="productCard.detailProduct.displayPrices as prices; else totalDashMobile">${{
          prices.total | numberNotRound }}</ng-container>
        <ng-template #totalDashMobile>—</ng-template>
      </p>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-0 pr-0 product-info">
      <p class="font-omicron-bold color-black mb-1 title-product">Descripción</p>
      <p class="font-omicron-medium color-gray-omicron info">
        {{ productCard.detailProduct.description }}
      </p>
    </div>
    <div class="row no-margin no-padding mb-3" *ngFor="
        let productAttribute of productCard.detailProduct.productAttributes;
        let index = index
      " [ngClass]="
        productCard.detailProduct.productAttributes.length > 1 &&
        index !== productCard.detailProduct.productAttributes.length - 1
          ? 'border-bottom'
          : ''
      ">
      <div class="col-7 col-sm-7 col-md-7 col-lg-7 col-xl-7 pl-0 pr-0 product-info" *ngIf="isShowSelects">
        <ng-container *ngTemplateOutlet="
            isContainerAndLabelEditable ? containerSelector : containerInfo;
            context: { index: index }
          ">
        </ng-container>
      </div>
      <div class="col-5 col-sm-5 col-md-5 col-lg-5 col-xl-5 pl-0 pr-0 d-flex justify-content-around align-items-center "
        *ngIf="isShowSelects">
        <div class="icon-size" *ngIf="showFavoriteButton && !productCard.detailProduct.isPackage">
          <app-favorite [whoRequest]="productCard.callPlace" [index]="productCard.index" [container]="
              productCard.detailProduct.productAttributes[index].container
            " [label]="productCard.detailProduct.productAttributes[index].label"
            [description]="productCard.detailProduct.description" [isLine]="productCard.detailProduct.isLine"
            [itemCode]="productCard.detailProduct.itemCode" [isFavorite]="
              productCard.detailProduct.productAttributes[index].isFavorite
            " [configFavorite]="configFavorite" [attributeIndex]="index" [emitChangeFavorite]="true"
            (favoriteChangeEmitter)="favoriteChange($event)">
          </app-favorite>
        </div>
        <div class="icon-size" *ngIf="showAddtoCarButton && !isAdvisorRoles">
          <app-shopping-cart-button [request]="productCard.callPlace" [container]="
              productCard.detailProduct.productAttributes[index].container
            " [label]="productCard.detailProduct.productAttributes[index].label" [quantity]="
              productCard.detailProduct.productAttributes[index].quantity
            " [isLine]="productCard.detailProduct.isLine" [itemCode]="productCard.detailProduct.itemCode"
            [configCartButton]="configCardButton" [disable]="isCardDisabled"
            [isPackage]="productCard.detailProduct.isPackage">
          </app-shopping-cart-button>
        </div>
        <div class="icon-size" *ngIf="
            isShoppingCard && isContainerAndLabelEditable &&
            productCard.detailProduct.productAttributes.length > 1
          ">
          <app-delete-product [product]="productCard.detailProduct" [message]="
              getDeleteMessage(
                productCard.detailProduct.productAttributes[index].container
              )
            " [typeDelete]="typeDeleteOptions.deleteProductFromListShoppingCar" [attributeIndex]="index"
            (wasDeleted)="deleteProductListShoppingCart($event)" [callPlace]="callPlace" [typeCart]="typeCart">
          </app-delete-product>
        </div>
        <div class="icon-size" *ngIf="
            isdetailOrderEdit &&
            productCard.detailProduct.productAttributes.length > 1
          ">
          <app-delete-product [product]="productCard.detailProduct" [message]="
              getDeleteMessage(
                productCard.detailProduct.productAttributes[index].container
              )
            " [typeDelete]="
              typeDeleteOptions.deleteProductFromDetailOrderListEdit
            " (wasDeleted)="deleteProductAttributeToRepurchase(index)" [callPlace]="callPlaceEditOrder"
            [typeCart]="typeCart">
          </app-delete-product>
        </div>
      </div>
      <div class="col-7 col-sm-7 col-md-7 col-lg-7 col-xl-7 pl-0 pr-0 mt-3 product-info" *ngIf="isShowSelects">
        <ng-container *ngTemplateOutlet="
            isContainerAndLabelEditable ? labelSelector : labelInfo;
            context: { index: index }
          ">
        </ng-container>
      </div>
      <div class="col-5 col-sm-5 col-md-5 col-lg-5 col-xl-5 mt-3 text-center pl-0 pr-0 product-info"
        *ngIf="isShowSelects">
        <p class="font-omicron-bold color-black mb-1 title-product">Costo</p>
        <p *ngIf="productCard.detailProduct.productAttributes[index].costPerPiece ===
          productCard.detailProduct.productAttributes[index].costPerPieceDiscount"
          class="font-omicron-medium color-gray-omicron info mb-0">
          $
          {{
          productCard.detailProduct.productAttributes[index].displayProductPrices.total | numberNotRound
          }}
        </p>
        <ng-container *ngIf="productCard.detailProduct.productAttributes[index].costPerPiece !==
          productCard.detailProduct.productAttributes[index].costPerPieceDiscount">
          <p class="font-omicron-medium color-gray-omicron info mb-0 discount">
            $
            {{
            productCard.detailProduct.productAttributes[index].displayProductPrices.totalWithoutDiscount |
            numberNotRound
            }}
          </p>
          <p class="discount-code font-omicron-medium info mb-0">
            $ {{
            productCard.detailProduct.productAttributes[index].displayProductPrices.total | numberNotRound
            }}
          </p>
        </ng-container>
      </div>
      <div class="col-7 col-sm-7 col-md-6 col-lg-6 col-xl-6 mt-2 mb-3 pl-0 pr-0 product-info" *ngIf="isShowSelects">
        <p class="font-omicron-bold color-black mb-1 title-product">
          {{
          productCard.detailProduct.isPackage
          ? "Cantidad de paquetes"
          : "Cantidad de piezas"
          }}
        </p>
        <div class="width-100 info" *ngIf="isdetailOrderEdit || (isShoppingCard && isContainerAndLabelEditable)">
          <app-counter-pieces [matStyle]="true" [pieceInit]="
              productCard.detailProduct.productAttributes[index].quantity
            " [isPackage]="productCard.detailProduct.isPackage" (newpieceEmitter)="newPieces($event, index)"
            (lockItems)="newPieces($event, index)">
          </app-counter-pieces>
        </div>
        <div *ngIf="!isdetailOrderEdit && !isShoppingCard || (isShoppingCard && !isContainerAndLabelEditable)"
          class="text-center">
          <p class="font-omicron-medium color-black color-gray-omicron info">
            {{ productCard.detailProduct.productAttributes[index].quantity }}
          </p>
        </div>
      </div>
    </div>
    <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-3 pl-0 product-info" *ngIf="!isShowSelects">
      <p class="font-omicron-bold color-black mb-1 title-product">
        {{
        productCard.detailProduct.isPackage
        ? "Cantidad de paquetes"
        : "Cantidad de piezas"
        }}
      </p>
      <div class="width-100 info" *ngIf="isdetailOrderEdit || (isShoppingCard && isContainerAndLabelEditable) ">
        <app-counter-pieces [matStyle]="true" [pieceInit]="productCard.detailProduct.productAttributes[0].quantity"
          [isPackage]="productCard.detailProduct.isPackage" (newpieceEmitter)="newPieces($event, 0)"
          (lockItems)="newPieces($event, 0)">
        </app-counter-pieces>
      </div>
      <div *ngIf="!isdetailOrderEdit && !isShoppingCard || (isShoppingCard && !isContainerAndLabelEditable)"
        class="text-center">
        <p class="font-omicron-medium color-black color-gray-omicron info">
          {{ productCard.detailProduct.quantity }}
        </p>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-0"
      *ngIf="isShowSelects && isContainerAndLabelEditable">
      <p class="mb-0 color-omicron font-omicron-medium text-underline cursor-pointer info" (click)="addContainer()">
        Agregar otro envase
      </p>
    </div>
    <div class="row mt-3 text-size-2" *ngIf="isUtility">
      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 border-top d-flex justify-content-center r-gap wrap text-center">
        <div class="d-flex justify-content-center r-gap space-gap wrap ">
          <ng-container *ngTemplateOutlet="utilityContent"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="moveShoppingCar context: { itemCode: productCard.detailProduct.itemCode }">
        </ng-container>
        <app-hoffman-message [hoffmanTextFlag]="hoffmanTextFlag"></app-hoffman-message>
      </div>
    </div>
  </div>
  <div class="row mt-3 text-size-2 d-flex justify-content-center text-center" *ngIf="(productCard.detailProduct.isPackage && showAddToSaveListShoppingCar && !isAdvisorRoles )
  || (productCard.detailProduct.isPackage &&  showAddToListShoppingCar && !isAdvisorRoles)">
    <ng-container *ngTemplateOutlet="moveShoppingCar context: { itemCode: productCard.detailProduct.itemCode }">
    </ng-container>
  </div>
</div>

<!-- Templates list -->
<ng-template #containerSelector let-index="index">
  <div class="max-width-product-card product-info  width-100">
    <p class="font-omicron-bold color-black mb-1 title-product" *ngIf="index === 0 || isMobile">
      Envase
    </p>
    <div id="{{'container-product-' + productCard.detailProduct.itemCode | lowercase }}"
      class="value-horizontal font-omicron-medium color-gray-omicron cursor-pointer info w-100" [ngClass]="
        productCard.detailProduct.productAttributes[index].containerError
          ? 'container-error'
          : ''
      " (click)="
        changeContainer(
          productCard.detailProduct.productAttributes[index],
          index
        )
      ">
      <p class="mb-0">
        {{ productCard.detailProduct.productAttributes[index].container }}
        <span class="mb-0 discount" *ngIf="
            productCard.detailProduct.productAttributes[index].displayPrices
              .costPerPiece !==
            productCard.detailProduct.productAttributes[index].displayPrices
              .costPerPieceDiscount
          ">
          |
          {{
          productCard.detailProduct.productAttributes[index].displayPrices
          .costPerPiece | numberNotRound
          }}
          MXN
        </span>
        <span class="mb-0" *ngIf="
            productCard.detailProduct.productAttributes[index].displayPrices
              .costPerPieceDiscount
          ">
          |
          {{
          productCard.detailProduct.productAttributes[index].displayPrices
          .costPerPieceDiscount | numberNotRound
          }}
          MXN
        </span>
      </p>
    </div>
    <div>
      <app-no-available-item-message [product]="productCard.detailProduct" [isProductMessage]="false"
        [attributeIndex]="index"></app-no-available-item-message>
    </div>
  </div>
</ng-template>

<ng-template #labelSelector let-index="index">
  <div class="max-width-product-card product-info">
    <p class="font-omicron-bold color-black mb-1 title-product" *ngIf="index === 0 || isMobile">
      Etiqueta
    </p>
    <mat-form-field appearance="outline"
      class="font-omicron-bold text-size-2 max-width-product-card width-100 product-info" [ngClass]="
        productCard.detailProduct.productAttributes[index].labelError || 
        productCard.detailProduct.productAttributes[index].invalidByLabel ||
        showErrorLabelMessage(productCard.detailProduct.productAttributes[index])
          ? 'label-error'
          : ''
      ">
      <mat-select id="{{'label-product-' + productCard.detailProduct.itemCode | lowercase }}"
        [value]="productCard.detailProduct.productAttributes[index].label" class="info">
        <mat-option (click)="onChangeLabel(label.description, index)" class="font-omicron-bold info"
          *ngFor="let label of labels" [value]="label.description">
          {{ label.description }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-error *ngIf="productCard.detailProduct.productAttributes[index].invalidByLabel ||
      showErrorLabelMessage(productCard.detailProduct.productAttributes[index])">
      No aplica para la promoción</mat-error>
  </div>
</ng-template>

<ng-template #costPerPiece>
  <div *ngIf="showCostoPor && productCard.detailProduct.displayPrices" class="product-info">
    <p class="font-omicron-bold color-black mb-1 title-product">
      {{
      productCard.detailProduct.isPackage
      ? "Costo por paquete"
      : "Costo por producto"
      }}
    </p>
    <p class="font-omicron-medium color-gray-omicron mb-0 info" *ngIf="!isDiscountVisible">
      ${{
      productCard.detailProduct.displayPrices.costPerPieceDiscount
      | numberNotRound
      }}
      <span class="font-omicron-bold color-omicron" *ngIf="showIvaLegend && productCard.detailProduct.taxRate > 0">
        *</span>
    </p>
    <div class="info" *ngIf="isDiscountVisible">
      <div>
        <span class="color-gray-omicron info" [ngClass]="
        productCard.detailProduct.displayPrices.costPerPiece !==
        productCard.detailProduct.displayPrices.costPerPieceDiscount &&
        showDialogDiscount && showCostoPor ? 'discount' : ''">
          ${{ productCard.detailProduct.displayPrices.costPerPiece | numberNotRound }}</span>
        <span class="font-omicron-bold color-omicron" *ngIf="showIvaLegend && productCard.detailProduct.taxRate > 0">
          *</span>
      </div>
      <ng-container *ngIf="
          productCard.detailProduct.displayPrices.costPerPiece !==
          productCard.detailProduct.displayPrices.costPerPieceDiscount &&
          showDialogDiscount && showCostoPor">
        <div class="info" [ngClass]="showCostoPor && 
          productCard.detailProduct.displayPrices.costPerPiece !==
          productCard.detailProduct.displayPrices.costPerPieceDiscount
          ? 'discount-code' : 'color-gray-omicron'">
          ${{
          productCard.detailProduct.displayPrices.costPerPieceDiscount
          | numberNotRound
          }}
          <span class="font-omicron-bold color-omicron" *ngIf="showIvaLegend && productCard.detailProduct.taxRate > 0">
            *</span>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #labelInfo let-index="index">
  <div class="product-info">
    <p class="font-omicron-bold color-black mb-1 title-product" *ngIf="index === 0 || isMobile">
      Etiqueta
    </p>
    <p class="font-omicron-medium color-gray-omicron mb-0 info">
      {{ productCard.detailProduct.productAttributes[index].label | uppercase }}
    </p>
  </div>
  <mat-error *ngIf="productCard.detailProduct.productAttributes[index].invalidByLabel ||
      showErrorLabelMessage(productCard.detailProduct.productAttributes[index])">
    No aplica para la promoción</mat-error>
</ng-template>

<ng-template #containerInfo let-index="index">
  <div class="product-info">
    <p class="font-omicron-bold color-black mb-1 title-product" *ngIf="index === 0 || isMobile">
      Envase
    </p>
    <p class="font-omicron-medium color-gray-omicron mb-0 info">
      {{
      productCard.detailProduct.productAttributes[index].container | uppercase
      }}
      <span class="discount" *ngIf="
          productCard.detailProduct.productAttributes[index].displayPrices
            .costPerPiece !==
            productCard.detailProduct.productAttributes[index].displayPrices
              .costPerPieceDiscount && showContainerDiscountNoButton
        ">
        |
        {{
        productCard.detailProduct.productAttributes[index].displayPrices
        .costPerPiece || 0 | numberNotRound
        }}
        MXN
      </span>
      <span *ngIf="
          productCard.detailProduct.productAttributes[index].displayPrices
            .costPerPieceDiscount > 0
        ">
        |
        {{
        productCard.detailProduct.productAttributes[index].displayPrices
        .costPerPieceDiscount | numberNotRound
        }}
        MXN</span>
    </p>
    <div>
      <app-no-available-item-message [product]="productCard.detailProduct" [isProductMessage]="false"
        [attributeIndex]="index"></app-no-available-item-message>
    </div>
  </div>
</ng-template>

<ng-template #utilityContent>
  <div class="space-gap margin-bottom d-flex align-items-center product-info" [ngClass]="isMobile ? 'flex-column':''">
    <div class="d-flex align-items-center mb-1">
      <p class="font-omicron-bold color-black mb-0 pr-1 title-product">
        Utilidad estimada por pieza
      </p>
      <img src="assets/icons/utilities.svg" alt="icon" />
    </div>
    <div class="cursor-pointer utilities-percent-container" (click)="openUtilitiesCalculator()">
      <p class="mb-0 font-omicron-medium color-gray-omicron info">
        ${{ productCard.detailProduct.utilityByPiece | numberNotRound }} =
        {{ productCard.detailProduct.utilityPercentage | numberNotRound }} %
      </p>
    </div>
  </div>
  <div class="space-gap d-flex align-items-center product-info" [ngClass]="isMobile ? 'flex-column':''">
    <p class="font-omicron-bold color-black mb-0 title-product">Utilidad estimada total</p>
    <p class="mb-0 font-omicron-medium color-gray-omicron info">
      ${{ productCard.detailProduct.utilityByProduct | numberNotRound }}
    </p>
  </div>
</ng-template>
<ng-template #moveShoppingCar let-itemCode="itemCode">
  <div class="d-flex align-items-center justify-content-end cursor-pointer" *ngIf="showAddToListShoppingCar">
    <app-save-shopping-cart-button [itemCode]="productCard.detailProduct.itemCode"
      [isLine]="productCard.detailProduct.itemCode" [typeCart]="typeCart" [cartOrigin]="typeCartStatus.savedCart"
      [cartDestination]="typeCartStatus.doctorShopping"
      [productAtributtes]="productCard.detailProduct.productAttributes" buttonText="Mover a carrito"
      imageRoute="assets/icons/car.svg">
    </app-save-shopping-cart-button>
  </div>
  <div class="d-flex align-items-center cursor-pointer" *ngIf="showAddToSaveListShoppingCar">
    <app-save-shopping-cart-button [itemCode]="productCard.detailProduct.itemCode"
      [isLine]="productCard.detailProduct.itemCode" [typeCart]="typeCart" [cartOrigin]="typeCartStatus.doctorShopping"
      [cartDestination]="typeCartStatus.savedCart" [productAtributtes]="productCard.detailProduct.productAttributes"
      buttonText="Guardar para después" imageRoute="assets/icons/move.svg">
    </app-save-shopping-cart-button>
  </div>
</ng-template>